import { render, staticRenderFns } from "./InboundTransferPaymentMethods.template.vue?vue&type=template&id=56b4c633&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b4c633",
  null
  
)

export default component.exports